import { useQuery } from "@tanstack/react-query";
import { MillOverviewData } from "../models/MillOverview";
import { getMillOverview } from "../repositories/millOverviewRepository";

interface UseMillOverviewDataProps {
	onError?: (error: Error) => void;
}

export const useMillOverviewData = ({
	onError,
}: UseMillOverviewDataProps = {}) => {
	const { data, isLoading } = useQuery<MillOverviewData, Error>({
		queryKey: ["millOverview"],
		queryFn: ({ signal }) => getMillOverview(signal),
		refetchInterval: 30000,
		onError,
	});

	return {
		data,
		isLoading,
	};
};
